import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logoIcon from '../assets/images/Icon-REGEXP.png';
import '../assets/css/footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer-main bg-dark text-light mt-auto">
      <Container className="footer-container">
        <Link to="/" className="footer-logo-link">
          <div className="navbar-logo-container">
            <div className="navbar-logo-icon">
              <img src={logoIcon} alt="HubExport" style={{ height: '2rem', width: 'auto', filter: 'brightness(0) invert(1)' }} />
            </div>
            <div className="navbar-logo-text">
              <div className="navbar-logo-main">HubExport</div>
            </div>
          </div>
        </Link>
        <nav className="footer-links-row">
          <Link to="/mentions-legales" className="footer-link">Mentions légales</Link>
          <Link to="/cgu" className="footer-link">CGU (Conditions Générales d'Utilisation)</Link>
          <Link to="/charte-referencement" className="footer-link">Charte de référencement</Link>
        </nav>
      </Container>
    </footer>
  );
};

export default Footer;
